import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const contactContactRelationDataClassName =
  DataClassName.CONTACT_CONTACT_RELATION
const contactContactRelationEndpoint = PisaDataClassEndpoint.CONTACT_CONTACT

export function pisaContactContactRelationDataClass(
  attributes: DataAttributeDefinitions,
) {
  return provideDataClass(contactContactRelationDataClassName, {
    title: contactContactRelationDataClassName,
    restApi: createPisaRestApiConfig(contactContactRelationEndpoint),
    attributes,
  })
}
